<template>
  <div
    class="scmcc-login-page"
    :style="{
      backgroundImage: `url(${envConst.SCMCC_HOST}/images/sign_bgtexture.png)`
    }"
  >
    <div class="login-page-wrapper">
      <div class="content">
        <div class="scmcc-forget-form-wrapper">
          <div :class="['errorInfo', { noShow: !errorInfo }]">
            {{ errorInfo }}
          </div>
          <div :class="['succcessInfo', { noShow: !succcessInfo }]">
            {{ succcessInfo }}
          </div>
          <div class="scmcc-forget-logo">
            <p class="tip-text1">重置密码</p>
          </div>
          <Form
            class="scmcc-forget-form"
            ref="formValidate"
            :model="forgetForm"
          >
            <FormItem class="scmcc-forget-form-item">
              <i-input
                filterable
                clearable
                placeholder="请输入域名"
                v-model="forgetForm.domainName"
              ></i-input>
            </FormItem>
            <FormItem class="scmcc-forget-form-item">
              <i-input
                filterable
                clearable
                placeholder="请输入手机号/邮箱"
                v-model="forgetForm.userName"
                @on-blur="handleUserName"
              ></i-input>
            </FormItem>
            <FormItem class="scmcc-forget-form-item item-no-margin-bottom">
              <i-input
                placeholder="请输入验证码"
                type="text"
                v-model="forgetForm.checkCode"
                @on-keyup="filterCode"
                @on-blur="handleCode"
              >
                <template v-slot:append>
                  <div
                    style="width:100%;height:52px;background: rgba(4, 70, 157,1)"
                    :class="!clickCheck ? 'gray' : ''"
                    @click="getCode"
                  >
                    <span v-if="show">{{ timemsg }}</span>
                    <span v-if="!show">重新获取({{ count }})</span>
                  </div>
                </template>
              </i-input>
              <i-input type="text" class="hide-input"></i-input>
            </FormItem>
            <FormItem class="scmcc-forget-form-item">
              <i-input type="password" class="hide-input"></i-input>
              <i-input
                placeholder="请输入新密码"
                v-model="forgetForm.password"
                :type="passwordHidden && 'password'"
                @on-blur="handlePassword"
              >
                <template v-slot:suffix>
                  <img
                    class="scmcc-forget-form-item-icon"
                    :src="
                      passwordHidden
                        ? require('../assets/images/login-page/ico_zhengyan_dis@2x.png')
                        : require('../assets/images/login-page/ico_biyan_dis@2x.png')
                    "
                    @click="passwordHidden = !passwordHidden"
                  />
                </template>
              </i-input>
            </FormItem>
            <FormItem class="scmcc-forget-form-item">
              <i-input
                placeholder="确认密码"
                v-model="forgetForm.password1"
                :type="passwordHidden1 && 'password'"
                @on-blur="handlePassword1"
              >
                <template v-slot:suffix>
                  <img
                    class="scmcc-forget-form-item-icon"
                    :src="
                      passwordHidden1
                        ? require('../assets/images/login-page/ico_zhengyan_dis@2x.png')
                        : require('../assets/images/login-page/ico_biyan_dis@2x.png')
                    "
                    @click="passwordHidden1 = !passwordHidden1"
                  />
                </template>
              </i-input>
            </FormItem>
            <FormItem class="scmcc-forget-form-item lastly denglu-loading">
              <Button
              style="background:#04469D;"
                type="primary"
                long
                :loading="loading"
                :disabled="disabled"
                @click="submitForget"
                >重置密码</Button
              >
            </FormItem>
          </Form>
          <p class="bottom-tip-text jump-text">
            <span @click="toLogin">直接登录</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { stringify } from 'qs'
import envConst from '../env-const.js'
export default {
  name: 'forget',
  data: () => ({
    envConst,
    errorInfo: '',
    succcessInfo: '',
    loading: false,
    passwordHidden: true,
    passwordHidden1: true,
    forgetForm: {
      domainName:'',
      userName: '',
      checkCode: '',
      password: '',
      password1: ''
    },
    userType: '',
    clickStat: true,
    clickCheck: false,
    timemsg: '获取验证码',
    count: '',
    show: true,
    timer: null,
    timer1: null
  }),
  created() {},
  methods: {
    toLogin() {
      this.$router.push('./login')
    },
    handleUserName() {
      let regEmail = new RegExp(
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,7})$/
      )
      let regPhone = new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/)
      if (!this.forgetForm.userName) {
        this.errorMesage('请输入手机号/邮箱')
        this.clickCheck = false
        return
      }
      if (
        !regEmail.test(this.forgetForm.userName) &&
        !regPhone.test(this.forgetForm.userName)
      ) {
        this.errorMesage('请输入正确手机号/邮箱')
        this.clickCheck = false
        return
      }
      if (regEmail.test(this.forgetForm.userName)) {
        this.userType = 1
        this.clickCheck = !this.clickStat ? false : true
      } else {
        this.userType = 2
        this.clickCheck = !this.clickStat ? false : true
      }
    },
    handleCode() {
      this.filterCode()
      let regCode = new RegExp(/^[0-9]{6}$/)
      if (!this.forgetForm.checkCode) {
        this.errorMesage('请输入验证码')
        return
      }
      if (!regCode.test(this.forgetForm.checkCode)) {
        this.errorMesage('请输入6位合法验证码')
        return
      }
    },
    handlePassword() {
      // let regPassward = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-z]|[A-Z]|[0-9]){6,16}$/);
      let regPassward = new RegExp(
        /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{6,16}$/
      )
      if (!this.forgetForm.password) {
        this.errorMesage('请输入新密码')
        return
      }
      if (!regPassward.test(this.forgetForm.password)) {
        this.errorMesage('请输入6-16位,数字、字母、符号至少两种以上组合新密码')
        return
      }
    },
    handlePassword1() {
      if (!this.forgetForm.password1) {
        this.errorMesage('请输入确认密码')
        return
      }
      if (this.forgetForm.password !== this.forgetForm.password1) {
        this.errorMesage('密码不一致')
        return
      }
    },
    filterCode() {
      this.forgetForm.checkCode = this.forgetForm.checkCode.replace(
        /[^\d]/g,
        ''
      )
    },
    getCode() {
      let regEmail = new RegExp(
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,7})$/
      )
      let regPhone = new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/)
      if (!this.clickStat) {
        this.errorMesage('请稍后点击获取验证码')
        return
      }
      if (!this.forgetForm.domainName) {
        this.errorMesage('请输入域名')
        this.clickCheck = false;
        return
      }
      if (!this.forgetForm.userName) {
        this.errorMesage('请输入手机号/邮箱')
        this.clickCheck = false
        return
      }
      if (
        !regEmail.test(this.forgetForm.userName) &&
        !regPhone.test(this.forgetForm.userName)
      ) {
        this.errorMesage('请输入正确手机号/邮箱')
        this.clickCheck = false
        return
      }
      if (this.userType == 1) {
        // 邮箱下发验证码
        this.$http
          .get(`${envConst.API_BASE_URL}/sctm/regist/sendEmail`, {
            params: { email: this.forgetForm.userName }
          })
          .then(res => {
            this.clickStat = false
            this.clickCheck = false
            if (res.data.bean.rtnCode == '0000') {
              this.sucessMessage('验证码已发送至邮箱，有效期5分钟')
              const TIME_COUNT = 60
              if (!this.timer1) {
                this.count = TIME_COUNT
                this.show = false
                this.timer1 = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--
                  } else {
                    this.show = true
                    clearInterval(this.timer1)
                    this.timer1 = null
                    this.timemsg = '重新发送'
                    if (this.forgetForm.userName) {
                      this.clickCheck = true
                    } else {
                      this.clickCheck = false
                    }
                    this.clickStat = true
                  }
                }, 1000)
              }
            } else {
              this.clickStat = true
              this.errorMesage(res.data.bean.rtnMessage)
            }
          })
          .catch(error => {
            this.clickStat = true
            console.log(error)
          })
      } else if (this.userType == 2) {
        // 短信验证码下发
        let params = {
          userPhone: this.forgetForm.userName,
          smsType: '2',
          domainName:this.forgetForm.domainName
        }
        this.$http
          .post(`${envConst.API_BASE_URL}/sctm/user/sendSmsCode`, params, {
            transformRequest: [data => stringify(data)]
          })
          .then(res => {
            this.clickCheck = false
            this.clickStat = false
            if (res.data.bean.rtnCode == '0000') {
              const TIME_COUNT = 60
              if (!this.timer) {
                console.log(111)
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--
                  } else {
                    this.show = true
                    clearInterval(this.timer)
                    this.timer = null
                    this.timemsg = '重新发送'
                    if (this.forgetForm.userName) {
                      this.clickCheck = true
                    } else {
                      this.clickCheck = false
                    }
                    this.clickStat = true
                  }
                }, 1000)
              }
            } else {
              this.clickStat = true
              this.errorMesage(res.data.bean.rtnMsg)
            }
          })
          .catch(error => {
            this.clickStat = true
            console.log(error)
          })
      }
    },
    submitForget() {
      let regEmail = new RegExp(
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,7})$/
      )
      let regPhone = new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/)
      let regCode = new RegExp(/^[0-9]{6}$/)
      // let regPassward = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-z]|[A-Z]|[0-9]){6,16}$/);
      let regPassward = new RegExp(
        /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{6,16}$/
      )
      if (!this.forgetForm.domainName) {
        this.errorMesage('请输入域名')
        return
      }
      if (!this.forgetForm.userName) {
        this.errorMesage('请输入手机号/邮箱')
        return
      }
      if (
        !regEmail.test(this.forgetForm.userName) &&
        !regPhone.test(this.forgetForm.userName)
      ) {
        this.errorMesage('请输入正确手机号/邮箱')
        return
      }
      if (!this.forgetForm.checkCode) {
        this.errorMesage('请输入验证码')
        return
      }
      if (!regCode.test(this.forgetForm.checkCode)) {
        this.errorMesage('请输入6位有效验证码')
        return
      }
      if (!this.forgetForm.password) {
        this.errorMesage('请输入新密码')
        return
      }
      if (!regPassward.test(this.forgetForm.password)) {
        this.errorMesage('请输入6-16位,数字、字母、符号至少两种以上组合新密码')
        return
      }
      if (!this.forgetForm.password1) {
        this.errorMesage('请输入确认密码')
        return
      }
      if (this.forgetForm.password !== this.forgetForm.password1) {
        this.errorMesage('密码不一致')
        return
      }
      this.resetPsaaword()
      return
      this.disabled = true

      // 校验验证码，校验正确则调用重置密码接口
      if (this.userType == 1) {
        this.$http
          .get(`${envConst.API_BASE_URL}/sctm/regist/checkVerCode`, {
            params: {
              email: this.forgetForm.userName,
              verCode: this.forgetForm.checkCode
            }
          })
          .then(res => {
            if (res.data.bean.rtnCode == '0000') {
              this.resetPsaaword()
            } else {
              this.disabled = false
              this.errorMesage(res.data.bean.rtnMessage)
            }
          })
          .catch(error => {
            this.disabled = false
            console.log(error)
          })
      } else if (this.userType == 2) {
        let params = {
          smsType: '2',
          smsCode: this.forgetForm.checkCode,
          userPhone: this.forgetForm.userName
        }
        this.$http
          .post(`${envConst.API_BASE_URL}/scsms/send/checkSmsCode`, params, {
            transformRequest: [data => stringify(data)]
          })
          .then(res => {
            if (res.data.bean.rtnCode == '0000') {
              this.resetPsaaword()
            } else {
              this.disabled = false
              this.errorMesage(res.data.bean.rtnMsg)
            }
          })
          .catch(error => {
            this.disabled = false
            console.log(error)
          })
      }
    },
    //重置密码接口
    resetPsaaword() {
      let params = {
        domainName:this.forgetForm.domainName,
        contactPhone: this.userType == 2 ? this.forgetForm.userName : '',
        userEmail: this.userType == 1 ? this.forgetForm.userName : '',
        userPwd: this.forgetForm.password,
        newPwdTwo: this.forgetForm.password1,
        smsType: this.userType + '',
        smsCode: this.forgetForm.checkCode,
      }
      this.$http
        .post('/sctm/user/updateUserPwdByPhoneOrEmail', params, {
          transformRequest: [
            data => {
              let _data = JSON.parse(JSON.stringify(data))
              _data.userPwd = this.$encrypt.encrypt(_data.userPwd)
              _data.newPwdTwo = _data.userPwd
              return stringify(_data)
            }
          ]
        })
        .then(({ data }) => {
          console.log(data)
          if (data.returnCode == 0) {
            if (data.bean == 1) {
              console.log('重置成功')
              // 跳转到目标地址
              this.$router.push('./login')
            } else {
              this.errorMesage(data.returnMessage)
            }
          } else {
            this.errorMesage(data.returnMessage)
          }
        })
    },
    // 显示登录错误信息
    errorMesage(error) {
      this.errorInfo = error
      if (this.timer1) clearTimeout(this.timer1)
      this.timer1 = setTimeout(() => {
        this.errorInfo = ''
        this.timer1 = null
      }, 3000)
    },
    // 显示正确信息
    sucessMessage(info) {
      this.succcessInfo = info
      if (this.timer2) clearTimeout(this.timer2)
      this.timer2 = setTimeout(() => {
        this.succcessInfo = ''
        this.timer2 = null
      }, 3000)
    }
  }
}
</script>

<style lang="stylus">
.scmcc-login-page
  height 100%
  width 100%
  overflow-y visible
  background #F3F6FC
  background-position center
  background-repeat no-repeat
  background-size 100% 100%

  .login-page-wrapper
    position relative
    width 100%
    height 100%
    margin 0 auto

  .content
    display flex
    justify-content center
    align-items flex-end
    float left
    position relative
    width 50%
    text-align center
    margin-top calc(50vh - 297px)
    margin-left calc(25% - 0px)

  .scmcc-forget-form-wrapper
    position relative
    width 486px
    padding 46px 56px 56px 56px
    border-radius 8px
    background rgba(255,255,255,0.86)
    box-shadow 0 0 26px 0 rgba(47, 92, 184, 0.4)

    .errorInfo
      position absolute
      background #F8DDDC
      border-radius 8px
      text-align center
      line-height 52px
      width 486px
      height 52px
      font-size 16px
      color #E76461
      top 0
      left 0

      &.noShow
        display none

    .succcessInfo
      position absolute
      background #DFF8FA
      border-radius 8px
      text-align center
      line-height 52px
      width 486px
      height 52px
      font-size 16px
      color #04CBD8
      top 0
      left 0

      &.noShow
        display none

    .scmcc-forget-logo
      text-align center
      margin 0 0 32px 0

      .tip-text1
        color #5e5f77
        font-size 20px
        font-weight bold

      .tip-text2
        margin-top 14px
        color #9191a1
        font-size 14px

      .scmcc-forget-logo-text
        font-size 16px
        font-weight 600
        color rgba(54, 107, 187, 1)
        line-height 1
        margin-left 8px

    .bottom-tip-text
      color #5e5f77
      font-size 14px

      span
        color #04469D
        cursor pointer

    .jump-text
      margin-top 24px
      text-align center

    .scmcc-forget-form
      .item-no-margin-bottom
        margin-bottom 0px !important

      .scmcc-forget-form-item
        margin-bottom 24px

        &.lastly
          margin-top 40px
          margin-bottom 0

        .ivu-select-selection
          height 52px

        .ivu-select-input, .ivu-input, .ivu-btn
          height 52px
          padding-left 20px
          color #515A6E
          font-size 16px

        .hide-input
          width 0px
          height 0px
          opacity 0

          .ivu-input
            margin-bottom 0px
            padding 0px
            border none
            height 0
            width 0
            opacity 0

          .ivu-input-inner-container
            height 0px

        .ivu-btn
          height 52px
          padding-left 20px
          font-size 20px
          color #ffffff
          border none

        .ivu-input-icon, .ivu-input-icon-clear
          line-height 52px

        .ivu-icon-ios-loading
          margin-top 10px
          line-height 32px

        .ivu-select-arrow
          right 12px
          color #BBC8D2

        .ivu-input-suffix
          display flex
          align-items center

          .scmcc-forget-form-item-icon
            width 20px

        .ivu-input-group-append
          color #ffffff
          font-size 16px
          cursor pointer
          position relative
          padding 0
          width 120px
          height 52px
          line-height 52px
          overflow hidden

          .gray
            background rgba(4, 70, 157,.6)!important

          .scmcc-forget-form-item-checkcode
            position absolute
            top 0
            left 0
            height 100%
            width 100%

        .scmcc-forget-form-item-domain
          padding 10px
          font-size 8px
      .denglu-loading
        .ivu-icon-ios-loading
              margin-top 2px
      .ivu-form-item-label
        padding-bottom 7px
        padding-top 15px

      .scmcc-forget-form-label
        display flex
        align-items center
        font-size 8px

        .scmcc-forget-form-icon
          width 13px
          height 13px
          margin-right 4px
</style>
